import { useState, useEffect } from "react";

import type FeatureImage from "@/model/feature-image";
// import { useCachedImage } from "@/hooks/use-feature-images";

import { Loader2 } from "lucide-react";

const ImageSlider = ({ images }: { images: FeatureImage[] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [, setError] = useState<string | null>(null);

  // const { data, isLoading } = useCachedImage(
  //   encodeURI(images[currentIndex].imageUrl),
  // );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 8000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative size-full">
      {images.map((image, index) => (
        <div
          key={index}
          className={`absolute size-full transition-opacity duration-1000 ease-in-out ${index === currentIndex ? "opacity-100" : "opacity-0"}`}
        >
          <div className="relative size-full items-center justify-center">
            {isLoading && (
              <div className="flex size-full items-center justify-center">
                <Loader2
                  aria-hidden="true"
                  className="size-10 animate-spin text-primary motion-reduce:animate-none"
                />
              </div>
            )}

            {/*
              TODO(a11y, 1.1.1 Non-text Content — A): alt={`Slider ${index}`} names the
              carousel position, not any information — a screen reader announces
              "Slider 0", which is meaningless. These are decorative marketing images and
              should be alt="". Not changed here because 17 tests in
              __tests__/pages/image-slider.test.tsx query these images by alt text or by
              role="img", and alt="" removes them from the accessibility tree. Tracked in
              docs/a11y/root-audit.md finding 16.
            */}
            <img
              src={images[currentIndex].imageUrl}
              alt={`Slider ${index}`}
              className="size-full object-cover"
              onLoad={() => setIsLoading(false)}
              onError={(_e) => {
                setIsLoading(false);
                setError("Failed to load image");
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageSlider;
